import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Tag} from "./fields";
import {Character, Object} from "./Shot";
import {Component} from "./setting";
import {host} from "./api";


export interface CharactersState {
    collection?: Array<Character>,
    lore?: Array<Character>,
    status: Status,
    error: string | null | undefined
}

const initialState: CharactersState = {
    collection: [],
    lore: [],
    status: Status.Idle,
    error: null,
}

export const fetchCharactersCollection = createAsyncThunk('fetchCharactersCollection', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/characters/collection/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchCharactersLore = createAsyncThunk('fetchCharactersLore', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/characters/lore/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveCharacter = createAsyncThunk('saveCharacter', async (params: { projectId: number, character: Character }) => {
    const response = await axios.post(`${host}/characters`,
        params.character,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteCharacter = createAsyncThunk('deleteCharacter', async (params: { projectId: number, characterId: number }) => {
    const response = await axios.delete(`${host}/characters/${params.characterId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeCharacterTag = createAsyncThunk('removeCharacterTag', async (params: { projectId: number, characterId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/characters/${params.characterId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addCharacterTag = createAsyncThunk('addCharacterTag', async (params: { projectId: number, characterId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/characters/${params.characterId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})


export const characterSlice = createSlice({
    name: 'characters',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(removeCharacterTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeCharacterTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addCharacterTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addCharacterTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveCharacter.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveCharacter.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteCharacter.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteCharacter.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchCharactersCollection.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchCharactersCollection.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.collection = action.payload
            })
            .addCase(fetchCharactersLore.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchCharactersLore.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.lore = action.payload.map((object: Object) => {
                    const component = object as Component
                    return {
                        ...component,
                        layers: component.cover ? [{source: component.cover}] : [],
                        scale: 100,
                        component: component,
                        type: 'Character'
                    }
                })
            })
    }
})
export default characterSlice.reducer;